<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <template #default>
          <h3 class="text-base font-medium">{{ t('title') }}</h3>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default="{ hide }">
      <div class="space-y-4 px-4 pb-4">
        <div class="bg-background-neutral-secondary rounded-2xl p-4">
          <p class="text-text-neutral-primary mb-2 font-medium">
            {{ t('examplesTitle') }}
          </p>
          <ul class="list-disc pl-5">
            <li
              v-for="example in examples"
              :key="example"
              class="text-text-neutral-secondary"
            >
              <span class="text-text-neutral-secondary text-sm">{{
                example
              }}</span>
            </li>
          </ul>
        </div>
        <FreeButton class="gray-button w-full" @click="hide">
          {{ t('close') }}
        </FreeButton>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import {
    FreeCloseButton,
    FreeHeader,
    FreeBottomSheet,
    FreeButton,
  } from '../../../shared/ui';

  const props = defineProps<{
    name: string;
  }>();

  const { t } = useI18n();

  const examples = computed(() => [
    t('firstExample'),
    t('secondExample'),
    t('thirdExample'),
    t('fourthExample'),
  ]);
</script>

<i18n src="../locales.json"></i18n>
